import React, { useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import ServicePageLayout from "../components/ServicePageLayout";
import OffersDialog from "pages/RestaurantMenu/components/OffersDialog";
import { useGuestSession } from "contexts/GuestSessionContext";
import { useNavigate } from "react-router-dom";
import { withGuestSearch } from "data/guestPortalDefaults";

import { LUXURY } from "data/guestLuxuryTheme";

const OffersPage = () => {
  const navigate = useNavigate();
  const { offerData, guestSearch, isRoom } = useGuestSession();
  const [open, setOpen] = useState(true);
  const offerItems = useMemo(
    () => (offerData || []).filter((item) => item.isActive),
    [offerData]
  );

  return (
    <ServicePageLayout
      title="Today's specials"
      subtitle="Tap a dish to order it from the menu."
      illustration="offers"
    >
      {offerItems.length === 0 ? (
        <Box
          sx={{
            p: 3,
            borderRadius: "18px",
            bgcolor: LUXURY.cardLight,
            border: `1px solid ${LUXURY.surfaceBorder}`,
          }}
        >
          <Typography sx={{ fontWeight: 700, wordBreak: "break-word", color: LUXURY.surfaceInk }}>
            No active offers right now
          </Typography>
          <Typography
            sx={{ color: LUXURY.surfaceHint, mt: 0.5, lineHeight: 1.5, wordBreak: "break-word" }}
          >
            You can still order from the full menu.
          </Typography>
          <Button
            sx={{ mt: 2, fontWeight: 800, color: LUXURY.goldDeep }}
            onClick={() =>
              navigate(withGuestSearch(isRoom ? "/guest/room-service" : "/guest/dine", guestSearch))
            }
          >
            Order food
          </Button>
        </Box>
      ) : (
        <Button
          variant="contained"
          onClick={() => setOpen(true)}
          sx={{
            minHeight: 48,
            fontWeight: 800,
            background: LUXURY.ctaGradient,
            color: LUXURY.forestDeep,
            borderRadius: "14px",
          }}
        >
          View {offerItems.length} special{offerItems.length === 1 ? "" : "s"}
        </Button>
      )}

      <OffersDialog
        open={open && offerItems.length > 0}
        onClose={() => setOpen(false)}
        isMobile
        offerItems={offerItems}
        onAddToCart={() => {
          setOpen(false);
          navigate(withGuestSearch(isRoom ? "/guest/room-service" : "/guest/dine", guestSearch));
        }}
      />
    </ServicePageLayout>
  );
};

export default OffersPage;
